export const TERM_AGREE_CHECK = `필수 동의 사항에 체크해주세요.`;
export const TERM_AGREE_JOIN = `필수약관에 동의해야<br/>회원가입이 가능합니다.`;
export const TERM_AGREE_JOIN_C = `웰몰에서 드리는 특별한 혜택과 서비스를 통해 가장 저렴하게 렌탈/구매 할 수 있는 기회 놓치실건가요?<br/>선택정보 수집 동의하고 혜택 및 서비스안내 받아보세요. `;
export const LOGIN_REQUIRE = `로그인이 필요한 페이지 입니다.<br/>로그인 페이지로 이동하시겠습니까?`;
export const LOGIN_FUNCTION_REQUIRE = `로그인이 필요한 기능 입니다.<br/>로그인 페이지로 이동하시겠습니까?`;
export const AUTH_TIMEOUT = `시간이 초과되었습니다.<br/>인증번호를 다시 요청해주세요.`;
export const AUTH_NOT_MATCH = `인증번호가 일치하지 않습니다.<br/>인증번호를 확인해주세요.`;
export const INFO_CHECK = `정보를 입력해주세요.`;
export const INPUT_INFO_CHECK = `입력하신 정보를 확인해주세요.`;
export const PAY_INFO_CHECK = `결제정보를 입력해주세요.`;
export const MY_PAY_INFO_CHECK = `본인명의 결제수단으로 입력해주세요.`;
export const ACCOUNT_INFO_CHECK = `계좌 정보를 다시 확인해주세요.`;
export const CARD_INFO_CHECK = `카드 정보를 다시 확인해주세요.`;
export const CODE_NUM_CHECK = `확인되지 않는 코드번호입니다.`;
export const INSTALL_ADDR_CHECK = `입력하신 주소에는 설치가 불가합니다.`;
export const ADD_CART_CHECK = `지금 중단하시면 주문결제내용이 저장되지 않습니다.<br/>장바구니에 담으시겠습니까?`;
export const GO_HOME = `홈으로 이동하시겠어요?`;
export const JOIN_CONFIRM = `고객님은 이미 렌탈 가입한 이력이<br/>확인되어 정보를 연동했습니다.`;
// export const JOIN_USER_CHECK = `고객님은 이미 웰몰에 가입하셨습니다.</br>가입한 아이디로 로그인을 해주세요.`;
export const JOIN_AGE_CHECK = `만14세 미만일경우 회원가입이 불가합니다.`;
export const JOIN_MISSION_SUCCESS = `미션성공 및 회원가입 완료로<br/>6만원쿠폰팩과 정기배송2천원<br/>할인쿠폰이 발급되었습니다.`;
export const JOIN_MISSION_FAIL = `회원가입 완료로<br/>6만원 쿠폰팩이 발급되었습니다.`;
export const RENTAL_ADD_CART = `지금 중단하시면</br>주문결제내용이 저장되지 않습니다.</br>장바구니에 담으시겠습니까?`;
export const HAVE_NOT_RENTAL = `렌탈 이용시, 제휴카드 등록이 가능합니다.`;
export const CHANGE_PASSWORD = `비밀번호가 변경되었습니다.<br/>로그인을 진행해주세요.`;
export const ORDER_FAIL = `주문접수가 정상적으로 처리되지 않는 상태입니다. 지속적으로 발생시 고객센터로 문의해 주세요.`;
export const RECOMMAND_CHECK = `추천코드를 입력하세요.`;

export const RESERVATION_ADVICE = `상담 예약이 완료되었습니다.<br>업무가 시작되는 대로 순차적으로 연락 드리겠습니다.`;
export const PDP_RESERVATION_ADVICE = `접수 완료되었습니다.<br>순차적으로 연락 드리겠습니다.`;
export const INPUT_QNA_TYPE = `문의 유형을 선택해 주세요.`;
export const INPUT_AVERAGESCORE = `별점을 선택하세요.`;
export const INPUT_CONTENTS = `내용을 입력하세요.`;
export const MAX_FILE_SIZE_CHECK = `20MB 이하의 사진파일만 등록해주세요.`;
export const PRODQNA_INSERT_COMPLETE = `제품 문의가 완료되었습니다.`;
export const PRODQNA_UPDATE_COMPLETE = `제품 문의 수정이 완료되었습니다.`;
export const OPTION_UPDATE = `옵션이 변경되었습니다.`;
export const COUPON_SELECT = `쿠폰이 발급되었습니다.`;
export const ALL_COUPON_SELECT = `개의 쿠폰이 발급되었습니다.`;
export const INPUT_BASKET_COMPLETE = `장바구니 담기 성공`;
export const OPTION_SELECT = `옵션을 선택해주세요.`;
export const OVERDUE_AMOUNT_CHECK = `미납금이 존재합니다.`;
export const OVERDUE_AMOUNT_FOR_PAY_CHG_CHECK = `미납금이 존재하여 변경이 불가합니다.`;

/* TODO 기획서에 없지만 필요한 message */
export const DELETE_CONFIRM = `삭제하시겠습니까?`;
export const DELETE_COMPLETE = `삭제가 완료되었습니다.`;
export const ALLOPTION_SELECT = `모든 옵션을 선택하세요.`;
export const INPUT_KEYWORD = `검색어를 입력하세요.`;
export const SUCCESS_CERTIFICATION = `휴대폰 본인인증이 완료되었습니다.`;
export const UPDATE_CONFIRM = `수정하시겠습니까?`;
export const LOADING_NO_DATA = `<br/>마지막 데이터 입니다.`;
export const LOADING_NO_RESULTS = `검색결과가 없습니다.`;

/* TODO 오류로 인한 임시 처리 */
export const MESSAGE_TYPE_NOAGREE = `임시 메시지`;
export const PROD_SEARCH_FAIL = `상품 정보를 조회할 수 없습니다.`;
export const SERVICE_COMM_ERROR = '서비스 이용에 불편을 드려 죄송합니다.<br>문제 지속 발생 시 고객센터로 문의바랍니다.';